import '../../App.css';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral'
import Footer from '../../components/footer/Footer'
import { StyleContext } from '../../context/StyleContext';
import { FaPlus } from 'react-icons/fa'
import { TbTrash, TbPencil } from 'react-icons/tb'
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import ModalCadastrarPlano from '../../components/modal/ModalCadastrarPlano';
import ModalExcluirPlano from '../../components/modal/ModalExcluirPlano';
import ModalEditarPlano from '../../components/modal/ModalEditarPlano';
import Tabela from '../../components/Tabela';

function PlanoNegocios() {
    const { Success, Error, loading, openModal, setOpenModal, ListaTipoPlanoNegocio, ListaPlanoNegocioConsulta, PlanoNegociosConsulta, setPlanoNegocioAtualKey, modalExcluirPlanoNegocio, setModalExcluirPlanoNegocio, modalEditarPlanoNegocio, setModalEditarPlanoNegocio, setEdicaoPlanoNegocio, StatusPlanoNegocio, ListaPlanoNegocioAvaliacao, setPlanoNegocio, Permissao, ListaFiltroPlanoNegocio, totalRegistrosPlanoNegocio, filtroPlanoNegocio, totalRegistrosFiltroPlanoNegocio } = useContext(ApiContext)
    const { h3Demanda, btnCriar, corTerciaria } = useContext(StyleContext)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const AdicionarPlano = () => {
        setOpenModal(true)
        setPlanoNegocio({
            avaliacao: "",
            indicador: "",
            valor: "",
            tipo: "",
            ativo: "",
            planoNegocioPaiKey: "",
            custo: false,
            data: false,
            pessoa: false
        })
    }

    const EditarPlano = (props) => {
        setModalEditarPlanoNegocio(true)
        setPlanoNegocioAtualKey(props.key)
        setEdicaoPlanoNegocio(props)
    }

    const DeletarPlano = (props) => {
        setPlanoNegocioAtualKey(props.key)
        setModalExcluirPlanoNegocio(true)
    }

    useEffect(() => {
        ListaTipoPlanoNegocio()
        ListaPlanoNegocioAvaliacao()
    }, [])

    useEffect(() => {
        if (searchTerm.trim() !== "") {
            ListaFiltroPlanoNegocio(searchTerm, currentPage, pageSize);
        } else {
            ListaPlanoNegocioConsulta(currentPage, pageSize);
        }
    }, [currentPage, searchTerm]);

    const totalRegistros = searchTerm.trim() !== "" ? totalRegistrosFiltroPlanoNegocio : totalRegistrosPlanoNegocio;
    const totalPages = Math.max(1, Math.ceil((totalRegistros || 0) / pageSize));

    return (
        <div>
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            {openModal &&
                <ModalCadastrarPlano closeModal={setOpenModal} currentPage={currentPage} />
            }
            {modalEditarPlanoNegocio &&
                <ModalEditarPlano currentPage={currentPage} />
            }
            {modalExcluirPlanoNegocio &&
                <ModalExcluirPlano currentPage={currentPage} />
            }
            <Header pagina={'Cadastros'} subpagina={'Plano de Negócios'}></Header>
            <MenuLateral></MenuLateral>
            <div className='container-principal'>
                <div className='demanda-header'>
                    {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                        <button className='btn-dash btn-criar' style={btnCriar} onClick={() => AdicionarPlano()}><FaPlus style={{ marginRight: "10px" }} />Cadastrar Plano de Negócios</button>
                    }
                </div>
                {loading ? (
                    <div className="loading-screen">
                        <div className="loader-container">
                            <div className="spinner"></div>
                        </div>
                    </div>
                ) : (
                    <div className='card card-table'>
                        <h3 className='h3-demanda' style={h3Demanda}>Plano de Negócios</h3>
                        <Tabela
                            data={searchTerm.trim() !== "" ? filtroPlanoNegocio : PlanoNegociosConsulta}
                            columns={[
                                { label: "Avaliação", field: "avaliacao", width: "20%", render: (x) => x?.avaliacaoPlanoNegocio?.descricao || "-"  },
                                { label: "Indicador", field: "indicador", width: "20%", render: (x) => x.indicador || "-" },
                                { label: "Tipo", field: "tipo", width: "10%", render: (x) => x.tipo || "-" },
                                { label: "Valor", field: "valor", width: "20%", render: (x) => x.valor || "-" },
                                { label: "Referência", field: "valor", width: "20%", render: (x) => x.custo === true ? 'Custo' : x.data === true ? 'Data' : x.pessoa === true ? 'Pessoa' : 'Sem referência' },
                                {
                                    label: "Ativo",
                                    width: "10%",
                                    align: "center",
                                    render: (x) => (
                                        <div className="checkbox-wrapper" style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                            <input type="checkbox" label=" Ativo" className="toggleBtn" onChange={() => StatusPlanoNegocio(x.key, !x.ativo, currentPage)} checked={x.ativo} />
                                        </div>
                                    ),
                                },
                                {
                                    label: "Opções",
                                    width: "10%",
                                    align: "center",
                                    render: (x) => (
                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                            <button onClick={() => EditarPlano(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                <TbPencil />
                                            </button>
                                            {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                                                <button onClick={() => DeletarPlano(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                    <TbTrash />
                                                </button>
                                            }
                                        </div>
                                    ),
                                },
                            ]}
                            loading={loading}
                            currentPage={currentPage}
                            totalPages={totalPages}
                            setCurrentPage={setCurrentPage}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            onSearch={(term) => {
                                setCurrentPage(1);
                                if (term.trim() !== "") {
                                    ListaFiltroPlanoNegocio(term, 1, 10);
                                } else {
                                    ListaPlanoNegocioConsulta(1, 10);
                                }
                            }}
                            corTerciaria={corTerciaria}
                        />
                    </div>
                )}
            </div>
            <Footer></Footer>
        </div>
    );
}

export default PlanoNegocios;